import {
  faEye,
  faEyeSlash,
  faLock,
  faLockOpen,
} from '@fortawesome/free-solid-svg-icons';
import {
  AwesomeIcon,
  Box,
  ButtonProps,
  TextInput,
  TextInputProps,
} from '@hover/blueprint';
import { size700 as paddingRight } from '@hover/tokens-space';
import React, { CSSProperties } from 'react';
import { animated } from 'react-spring';
import styled from 'styled-components';

import { Button } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';

type PasswordInputProps = TextInputProps & {
  onToggle: ButtonProps['onPress'];
  locked?: boolean;
  style: CSSProperties;
};

const Input = styled(TextInput)({ paddingRight });

const PasswordInput = ({
  locked = false,
  onToggle,
  style,
  ...props
}: PasswordInputProps) => {
  const t = useTranslate('shared');

  return (
    <animated.div style={style}>
      <Input
        {...props}
        iconBefore={locked ? faLock : faLockOpen}
        type={locked ? 'password' : 'text'}
        width="100%"
      />
      <Box
        alignItems="center"
        bottom={0}
        flexDirection="row"
        position="absolute"
        right={200}
        top={0}
      >
        <Button
          fill="minimal"
          label={
            locked
              ? t('passwordInput.showPassword')
              : t('passwordInput.hidePassword')
          }
          onPress={onToggle}
          shape="square"
          type="button"
        >
          <AwesomeIcon color="neutral600" icon={locked ? faEye : faEyeSlash} />
        </Button>
      </Box>
    </animated.div>
  );
};

export { PasswordInput };
